import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DataPackageList } from '@usecase/package/get-package/get-package.interface';

@Component({
  selector: 'voucher-card',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './voucher-card.component.html',
  styleUrl: './voucher-card.component.scss'
})
export class VoucherCardComponent {
  data = input<DataPackageList>();
}
